import { Delete } from "@mui/icons-material"
import { Box, Button, Grid, IconButton, InputAdornment, List, ListItem, ListItemText, ListSubheader, MenuItem, Stack, TextField, Typography } from "@mui/material"
import React from "react"
import { EquipmentCancelConf } from "../../Objects/EquipmentCancelConf"

export interface EquipmentCancelConfListProps {
    equipmentCancelConfList: EquipmentCancelConf[]
    onDelete?: (equipmentCancelConf: EquipmentCancelConf) => void
    onCreate?: (equipmentCancelConf: EquipmentCancelConf) => void
}

const unit_name = {
    "HOUR": "時間前",
    "WORK": "営業日前",
    "DAY": "日前",
}

const EquipmentCancelConfList: React.FC<EquipmentCancelConfListProps> = ({
    equipmentCancelConfList,
    onDelete,
    onCreate,
}) => {

    const onSubmit = React.useCallback((e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()

        const formData = new FormData(e.currentTarget)
        const equipmentCancelConf: EquipmentCancelConf = {}
        equipmentCancelConf.ccfg_start = parseInt(formData.get("ccfg_start")?.toString() ?? "");
        equipmentCancelConf.ccfg_end = parseInt(formData.get("ccfg_end")?.toString() ?? "");
        const ccfg_unit = formData.get("ccfg_unit")?.toString() ?? ""
        equipmentCancelConf.ccfg_unit = Object.keys(unit_name).find(value => value === ccfg_unit) as "HOUR" | "WORK" | "DAY" | undefined;
        equipmentCancelConf.ccfg_raito = parseInt(formData.get("ccfg_raito")?.toString() ?? "");

        if (onCreate) {
            onCreate(equipmentCancelConf)
        }

    }, [onCreate])

    return (
        <Box>
            <List
                dense
                subheader={
                    <ListSubheader
                        disableGutters
                        sx={{
                            fontSize: 20,
                        }}
                    >レンタル機材キャンセル料</ListSubheader>
                }
            >
                {equipmentCancelConfList.map(equipmentCancelConf => {
                    if (!equipmentCancelConf.ccfg_unit) {
                        return <></>
                    }
                    return (
                        <ListItem key={equipmentCancelConf.ccfg_id}
                            secondaryAction={
                                onDelete &&
                                (
                                    <IconButton edge="end" aria-label="delete"
                                        onClick={() => {
                                            onDelete(equipmentCancelConf)
                                        }}
                                    >
                                        <Delete />
                                    </IconButton>
                                )
                            }
                        >
                            <ListItemText
                                sx={{
                                    width: "30%",
                                    textAlign: "right",
                                }}
                            >{`${equipmentCancelConf.ccfg_start}～${equipmentCancelConf.ccfg_end}`} {unit_name[equipmentCancelConf.ccfg_unit]}</ListItemText>
                            <ListItemText
                                sx={{
                                    width: "30%",
                                    textAlign: "center",
                                }}
                            >{`機材レンタル代の ${equipmentCancelConf.ccfg_raito}%`}</ListItemText>
                        </ListItem>
                    )
                })}
            </List>
            <Box
                component={"form"}
                onSubmit={onSubmit}
            >
                <Grid container
                    spacing={1}
                    maxWidth={400}
                    mx={"auto"}
                >
                    <Grid item xs={12} md={12}>
                        <Stack
                            direction={"row"}
                            alignItems={"center"}
                            spacing={1}
                        >
                            <TextField
                                name="ccfg_start"
                                size="small"
                                sx={{
                                    width: "30%"
                                }}
                            />
                            <Typography>～</Typography>
                            <TextField
                                name="ccfg_end"
                                size="small"
                                sx={{
                                    width: "30%"
                                }}
                            />
                            <TextField
                                name="ccfg_unit"
                                size="small"
                                sx={{
                                    width: "40%"
                                }}
                                select
                                defaultValue={"HOUR"}
                            >
                                {Object.entries(unit_name).map(value => {
                                    return <MenuItem value={value[0]} key={value[0]}>{value[1]}</MenuItem>
                                })}
                            </TextField>
                        </Stack>
                    </Grid>
                    <Grid item xs={10} md={8}>
                        <TextField
                            name="ccfg_raito"
                            size="small"
                            fullWidth
                            InputProps={{
                                startAdornment: <InputAdornment position="start">機材レンタル代の</InputAdornment>,
                                endAdornment: <InputAdornment position="end">%</InputAdornment>,
                            }}
                        />
                    </Grid>
                    <Grid item xs={2} md={4}>
                        <Button
                            variant="outlined"
                            type="submit"
                            fullWidth
                        >登録</Button>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    )
}

export default EquipmentCancelConfList